module.exports = __webpack_public_path__ + "static/media/aboutUs.58ef33a2.png";